<template>
  <!-- name: '历年捐赠项目' -->
  <div class="historyWrap">
    <div class="tabBox">
      <ul>
        <li
          :class="curYear === item ? 'actClass' : ''"
          v-for="(item, index) in yearsList"
          :key="index"
          @click="changeTab(item)"
        >
          {{ item }}
          <span class="lineClass"></span>
        </li>
      </ul>
      <div class="maskBox"></div>
    </div>
    <div class="listBox">
      <ul>
        <li v-for="(item, index) in curList" :key="index">
          <img
            :src="item.picUrls"
            alt=""
            class="imgClass"
            v-default-img="defaultImgUrl"
          />
          <div class="infoBox">
            <h5>{{ item.theme }}</h5>
            <div class="contentBox">
              <div class="labelBox">
                <span class="labelClass"
                  ><img src="https://img.bbalt.cn/imgh5/home/icon_place.svg" />{{
                    item.provinceName
                  }}</span
                >
                <span class="labelClass"
                  ><img src="https://img.bbalt.cn/imgh5/home/icon_size.svg" />{{
                    item.sizeName
                  }}</span
                >
              </div>
            </div>
            <div class="countClass">
              募集<span>{{ item.donateCount }}</span
              >件
            </div>
          </div>
        </li>
      </ul>
      <van-loading v-if="isLazyLoad">加载中...</van-loading>
    </div>
  </div>
</template>

<script>
import { historyProject } from "@/api/donate";
import mixin from "@/utils/mixin.js";
export default {
  mixins: [mixin],
  components: {},
  data() {
    return {
      yearsList: ["2023", "2022", "2021", "2020", "2019", "2018"],
      curYear: "2023",
      isShow: false,
      listQuery: { pageNo: 1, pageSize: 10 },
      total: 0,
      isLazyLoad: true,
      curDataList: [],
      curList: [],
      defaultImgUrl: `https://img.bbalt.cn/imgh5/user_default.svg`,
    };
  },
  created() {
    this.getHistoryProjects();
  },
  methods: {
    changeTab(item) {
      this.curYear = item;
      this.isLazyLoad = true;
      this.listQuery = { pageNo: 1, pageSize: 10 };
      this.getHistoryProjects(1, false);
    },
    async getHistoryProjects(pageNo, isLazy) {
      if (isLazy) {
        this.isLazyLoad = true;
      }
      this.listQuery.pageNo = pageNo > 1 ? pageNo : this.listQuery.pageNo;
      const { content } = await historyProject({
        ...{ year: this.curYear },
        ...this.listQuery,
      });
      this.curList = isLazy
        ? [...this.curList, ...content.records]
        : content.records;
      this.total = content.total;
      this.isLazyLoad = false;
    },
  },
  mounted() {
    let dom = document.querySelector(".listBox");
    this.handleScrollLazy(
      dom,
      this.listQuery.pageNo,
      this.listQuery.pageSize,
      this.total,
      this.getHistoryProjects
    );
  },
};
</script>

<style lang="scss" scoped>
.historyWrap {
  width: 100%;
  height: calc(100% - 100px);
  overflow: hidden;
  font-family: PingFangSC, PingFang SC;
  .tabBox {
    width: 100%;
    height: 180px;
    background-image: url("https://img.bbalt.cn/imgh5/donate/bg_history.png");
    background-repeat: no-repeat;
    background-size: 100%;
    padding-top: 32px;
    position: relative;
    ul {
      display: flex;
      justify-content: flex-start;
      width: 70%;
      margin: 0px 190px 0px 32px;
      overflow-x: auto;
      overflow-y: hidden;
      height: 50px;
      li {
        font-size: 32px;
        font-weight: 400;
        color: #fe66a6;
        margin-left: 32px;
        position: relative;
        .lineClass {
          height: 37px;
          width: 37px;
          border-bottom: 1px dashed #fe66a6;
          position: absolute;
          bottom: 0px;
          left: 15px;
          border-radius: 17px;
          display: none;
        }
        &.actClass {
          font-size: 36px;
          font-weight: 600;
          .lineClass {
            display: inline-block;
          }
        }
      }
    }
    .maskBox {
      position: absolute;
      left: 68%;
      top: 32px;
      width: 50px;
      height: 56px;
      background: linear-gradient(
        90deg,
        rgba(254, 239, 246, 0) 0%,
        #feeff6 100%
      );
    }
  }
  .listBox {
    top: -70px;
    width: 100%;
    height: calc(100% - 100px);
    overflow: auto;
    background: #ffffff;
    box-shadow: 1px -1px 16px 0px rgba(195, 63, 119, 0.2);
    border-radius: 0px 64px 0px 0px;
    position: relative;
    padding-top: 64px;
    display: flex;
    flex-flow: column;
    align-items: center;
    padding-bottom: 30px;
    li {
      width: 686px;
      min-height: 200px;
      background: #fafafa;
      border-radius: 16px;
      display: flex;
      margin-bottom: 24px;
      .imgClass {
        width: 200px;
        height: 200px;
        border-radius: 16px;
        margin-right: 24px;
        object-fit: cover;
      }
      .infoBox {
        width: 430px;
        position: relative;
        h5 {
          width: 100%;
          font-size: 30px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: #333333;
          text-align: left;
          margin-top: 16px;
          margin-bottom: 10px;
          font-weight: 600;
        }
        .contentBox {
          display: flex;
          justify-content: space-between;
          margin-top: 10px;
          .labelBox {
            display: flex;
            img {
              width: 20px;
              height: 20px;
              margin: 0px 4px;
            }
          }
        }
        .countClass {
          margin: 17px 0px;
          font-size: 24px;
          font-weight: 400;
          color: #999999;
          span {
            font-size: 26px;
            font-weight: 600;
            color: #fe66a6;
            margin: 0px 4px;
          }
        }
      }
    }
  }
}

.labelClass {
  padding: 0px 8px;
  height: 30px;
  background: #679fd2;
  border-radius: 4px;
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 110px;
  width: auto;
  margin-right: 8px;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
</style>
